export default __webpack_public_path__ + "static/media/dashboard.ca64e513.png";